import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { DocumentTitle } from 'src/routes/components';

import { getConfig } from 'src/global-config';

import { SplashScreen } from 'src/components/loading-screen/splash-screen';

import { AuthGuard } from 'src/auth/guard';
import { HRAuthGuard } from 'src/auth/guard/hr-guard';

// ----------------------------------------------------------------------

const IntegrationsCallbackPage = lazy(() => import('src/pages/integrations/callback'));

/**
 * Where a provider returns after an OAuth approval. It is guarded like any other authenticated page
 * because it finishes the connect with the signed-in user's token; the guards keep the query string
 * on the way through a sign-in, so an expired session resumes the flow rather than losing it.
 */
export function getIntegrationsRoutes(): RouteObject[] {
  const CONFIG = getConfig();

  const callbackPage = (
    <Suspense fallback={<SplashScreen />}>
      <>
        <DocumentTitle />
        <IntegrationsCallbackPage />
      </>
    </Suspense>
  );

  return [
    {
      path: 'integrations',
      children: [
        {
          path: 'callback',
          element: CONFIG.auth.skip ? (
            callbackPage
          ) : (
            <AuthGuard>
              <HRAuthGuard>{callbackPage}</HRAuthGuard>
            </AuthGuard>
          ),
        },
      ],
    },
  ];
}
